import React from 'react';
import AuditTableViewer from './AuditTableViewer';
import { IconButton } from '@mui/material';
import SimpleModal from '../../teal-react/components/organisms/SimpleModal';
import { History } from '@mui/icons-material';

const AuditViewer = (props) => {
  const [show, setShow] = React.useState(false);

  return (
    <>
      <IconButton onClick={() => setShow(true)}>
        <History />
      </IconButton>
      {show ? (
        <SimpleModal open={true} onClose={() => setShow(false)}>
          <AuditTableViewer {...props} />
        </SimpleModal>
      ) : null}
    </>
  );
};

export default AuditViewer;
